import { ToolbarSlideshow } from './ToolbarSlideshow';

export default ToolbarSlideshow;
